export interface StatisticState {
    customStatisticDetail: CustomDetailItem[];
    customStatisticGroup: CustomGroupItem[];
    customStatisticGroupMessageCount: number;
    customGroupings: {
        customGroup: string[];
        customGroupByOptionally: string[];
    }
}

export interface CustomDetailItem {
    id: string;
    create_date: string;
    originator: string;
    recipient: string;
    partner: string;
    service_provider?: string;
    message?: string;
    status: string;
    error_code: number;
}

export class CustomDetailItemInfo {
    id: string|null = null;
    transport_message_id?: string;
    create_date: string|null = null;
    sent_date?: string;
    delivery_date?: string;
    read_date?: string;
    defer_date?: string;
    expire_date?: string;
    external_id?: string;
    service_provider?: string;
    originator: string|null = null;
    recipient: string|null = null;
    parent_message_id?: string;
    parent_message_channel?: string;
    bulk_id?: string;
    partner: string|null = null;
    partner_user_login?: string;
    status: string|null = null;
    error_code?: number;
    error_description?: string;
    message_type?: string;
    message?: string;
    image_link?: string;
    button_name?: string;
    button_link?: string;
    priority?: number;
    partner_price?: string;
    provider_price?: string;
    broker_account_login?: string;
    template_id?: string;
    connection_type?: string;
    custom_parameters?: string;
    ext_id1?: string;
    ext_id2?: string;
    ext_id3?: string;
    ext_id4?: string;
    ext_id5?: string;
    custom_data?: object;
}

export class CustomDetailFilterParams {
    date_from: string;
    date_to: string;
    originator?: string = undefined;
    recipient?: string = undefined;
    partner?: string = undefined;
    service_provider?: string = undefined;
    message_category?: string = undefined;
    status?: string = undefined;
    error_code?: number = undefined;
    message_type?: string = undefined;
    flag?: string|null = null;
    sent_date_from?: string = undefined;
    sent_date_to?: string = undefined;
    deliver_date_from?: string = undefined;
    deliver_date_to?: string = undefined;
    template_id?: number = undefined;
    bulk_id?: string = undefined;
    broker_account_login?: string = undefined;
    partner_user_login?: string = undefined;
    id?: string = undefined;
    transport_message_id?: string = undefined;
    external_id?: string = undefined;
    ext_id1?: string = undefined;
    ext_id2?: string = undefined;
    ext_id3?: string = undefined;
    ext_id4?: string = undefined;
    ext_id5?: string = undefined;
    message_direction: string;
    page_number: number = 1;

    constructor(date_from: string, date_to: string) {
        this.date_from = date_from;
        this.date_to = date_to;
        this.message_direction = "mt";
        this.page_number = 1;
    }
}

export interface CustomGroupItem {
    date?: string;
    originator?: string;
    service_provider?: string;
    partner?: string;
    template_id?: string;
    bulk_id?: string;
    delivered: number;
    read: number;
    not_delivered: number;
    transmitted: number;
    expired: number;
    failed: number;
    rejected: number;
    deferred: number;
    total: number;
    partner_price: string;
    provider_price: string;
}

export class CustomGroupFilterParams {
    date_from: string;
    date_to: string;
    group_by: string;
    originator?: string = undefined;
    service_provider?: string = undefined;
    partner?: string = undefined;
    template_id?: number = undefined;
    bulk_id?: string = undefined;
    message_category?: string = undefined;
    broker_account_login?: number = undefined;
    message_type?: number = undefined;
    message_direction: string;

    constructor(date_from: string, date_to: string, group_by: string) {
        this.date_from = date_from;
        this.date_to = date_to;
        this.group_by = group_by;
        this.message_direction = "mt";
    }
}
